import script from "./CategoryLozenge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryLozenge.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryLozenge.vue?vue&type=style&index=0&id=9358bc24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9358bc24"]])

export default __exports__